import { utils } from "@intrasync/utils";
import { makeAutoObservable } from "mobx";
import RootStore from "stores/RootStore";
import ServiceStore from "stores/ServiceStore";

class JobPanelCountsStore {
  rootStore: RootStore;
  showArchived = false;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  setShowArchived = (value: boolean): void => {
    this.showArchived = value;
  };

  get entities() {
    // const { jobStore, jobStatsPanelCountStore } = this.rootStore;
    const jobStore = this.rootStore.jobStore as ServiceStore;
    const jobStatsPanelCountStore = this.rootStore
      .jobStatsPanelCountStore as ServiceStore;
    if (!jobStore?.entities?.length) return [];
    const jobs = jobStore.entities
      .slice()
      .filter((currentJob) => {
        if (this.showArchived) {
          return true;
        }
        return !currentJob.archived;
      })
      .map((currentJob) => {
        const jobNumber = currentJob.jobNumber;
        const foundJobStats = jobStatsPanelCountStore.entities
          .slice()
          .find((i) =>
            utils.isSameJobNumber(i.jobNumber as number, jobNumber as number)
          ) as
          | {
              uniqueMarkCount: number;
              panelCount: { panel: number; total: number; assembly: number };
              jobsProductTypes: { [key: string]: { totalSqFt: number } };
            }
          | undefined;
        if (!foundJobStats) {
          return {
            jobNumber: `${jobNumber}`,
            jobName: currentJob?.shortName
              ? currentJob.shortName
              : currentJob?.name,
            totalCount: 0,
            panelCount: 0,
            assemblyCount: 0,
            markCount: 0,
            totalSqFt: 0,
            productType: [],
            markToPanelRatio: `0%`,
          };
        }

        const markToPanelRatio =
          utils.roundTo(
            (foundJobStats?.uniqueMarkCount /
              foundJobStats?.panelCount?.panel) *
              100
          ) || 0;
        let totalSqFt = 0;

        const productTypes = Object.keys(foundJobStats?.jobsProductTypes).join(
          ", "
        );
        Object.values(foundJobStats?.jobsProductTypes).map((stats) => {
          if (stats.totalSqFt) {
            totalSqFt += stats.totalSqFt;
          }
          return stats;
        });
        return {
          jobNumber: `${jobNumber}`,
          jobName: currentJob?.shortName
            ? currentJob.shortName
            : currentJob?.name,
          totalCount: foundJobStats?.panelCount?.total,
          panelCount: foundJobStats?.panelCount?.panel,
          assemblyCount: foundJobStats?.panelCount?.assembly,
          markCount: foundJobStats?.uniqueMarkCount,
          totalSqFt: totalSqFt,
          productType: productTypes,
          markToPanelRatio: `${markToPanelRatio}%`,
        };
      });

    return jobs;
  }
}

export default JobPanelCountsStore;
